import React from 'react';
import armurerieImage from '../../../../../assets/ateliers/detective-clux/halloween/lieux/armurerie.png';
import bibliothequeImage from '../../../../../assets/ateliers/detective-clux/halloween/lieux/bibliotheque.png';
import jardinImage from '../../../../../assets/ateliers/detective-clux/halloween/lieux/jardin.png';
import laboratoireImage from '../../../../../assets/ateliers/detective-clux/halloween/lieux/laboratoire.png';
import salleDeBalImage from '../../../../../assets/ateliers/detective-clux/halloween/lieux/salle_de_bal.png';
import baguetteMagiqueImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/baguette_magique.png';
import boiteABijouxImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/boite_a_bijoux.png';
import bouleDeCristalImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/boule_de_cristal.png';
import chandelierImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/chandelier.png';
import cleImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/cle.png';
import clochetteImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/clochette.png';
import coffreImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/coffre.png';
import collierImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/collier.png';
import couronneDeFleursImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/couronne_de_fleurs.png';
import flaconImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/flacon.png';
import grimoireImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/grimoire.png';
import lanterneImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/lanterne.png';
import masqueImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/masque.png';
import miroirImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/miroir.png';
import montreImage from '../../../../../assets/ateliers/detective-clux/halloween/objets/montre.png';
import araigneeImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/araignee.png';
import chatImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/chat.png';
import citrouilleImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/citrouille.png';
import epouvantailImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/epouvantail.png';
import fantomeImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/fantome.png';
import farfadetImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/farfadet.png';
import feeImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/fee.png';
import frankensteinImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/frankenstein.png';
import loupGarouImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/loup_garou.png';
import marieeImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/mariee.png';
import momieImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/momie.png';
import sorciereImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/sorciere.png';
import squeletteImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/squelette.png';
import vampireImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/vampire.png';
import zombieImage from '../../../../../assets/ateliers/detective-clux/halloween/personnages/zombie.png';
import enveloppeImage from '../../../../../assets/ateliers/detective-clux/halloween/presentation/enveloppe.png';
import fondImage from '../../../../../assets/ateliers/detective-clux/halloween/presentation/fond.png';
import logoImage from '../../../../../assets/ateliers/detective-clux/halloween/presentation/logo.png';
import fondReglagesImage from '../../../../../assets/ateliers/detective-clux/halloween/reglages/fond.png';
import parcheminImage from '../../../../../assets/ateliers/detective-clux/halloween/reglages/parchemin.png';
import detectiveImage from '../../../../../assets/ateliers/detective-clux/halloween/resultats/detective_clux.png';
import roiImage from '../../../../../assets/ateliers/detective-clux/halloween/resultats/roi.png';
import { DetectiveCluxConfig, DetectiveCluxItem } from '../../config/interfaces';

export const HALLOWEEN_TITLE =
  "Les enquêtes du Détective Clux : Mystère au château pour Halloween"

/** Personnages, objets et lieux de l'enquête (données issues des spécifications) */
const HALLOWEEN_ITEMS: DetectiveCluxItem[] = [
  {
    id: "sorciere",
    label: "la sorcière",
    type: "personnage",
    image: sorciereImage,
    descriptions: {
      1: "Elle a de longs cheveux roux et bouclés. Elle porte un grand chapeau noir.",
      2: "Cette jeune fille aux cheveux roux et bouclés porte une grande cape sombre décorée de lunes et d'étoiles. Sur sa tête se trouve un grand chapeau noir.",
      3: "Cette mystérieuse demoiselle à la chevelure flamboyante arbore un imposant chapeau sombre ainsi qu'une cape parsemée de symboles célestes.",
    },
  },
  {
    id: "araignee",
    label: "l'araignée",
    type: "personnage",
    image: araigneeImage,
    descriptions: {
      1: "Elle a huit pattes couvertes de poils roses et noirs. Elle aime tisser des toiles.",
      2: "Cette petite créature possède huit longues pattes couvertes de poils roses et noirs. Ses membres lui permettent de tisser des toiles.",
      3: "Cette étrange créature possède huit pattes velues, parées de bandes roses et noires. Elle excelle dans l'art de tisser des toiles.",
    },
  },
  {
    id: "vampire",
    label: "le vampire",
    type: "personnage",
    image: vampireImage,
    descriptions: {
      1: "Il a des cheveux noirs et de longues canines. Il porte une cape noire avec un col rouge.",
      2: "Ce jeune garçon aux cheveux noirs dévoile ses dents pointues en souriant. Une cape sombre au grand col rouge recouvre ses épaules.",
      3: "Lorsqu'il sourit, on entrevoit deux canines acérées. Sa chevelure ténébreuse est aussi noire que la cape qui lui couvre les épaules.",
    },
  },
  {
    id: "loup-garou",
    label: "le loup-garou",
    type: "personnage",
    image: loupGarouImage,
    descriptions: {
      1: "Il a des poils marron, des oreilles pointues et de grandes dents.",
      2: "Cette créature au pelage brun possède des crocs pointus. Ses oreilles dressées et ses sourcils froncés lui donnent un air menaçant.",
      3: "Son pelage brun et hirsute, ainsi que ses oreilles dressées, rappellent un animal sauvage. Ses crocs acérés suffiraient à faire fuir les plus courageux.",
    },
  },
  {
    id: "zombie",
    label: "le zombie",
    type: "personnage",
    image: zombieImage,
    descriptions: {
      1: "Il a la peau verte et les cheveux roux décoiffés. Ses vêtements sont sales et tout déchirés.",
      2: "Ce drôle de garçon à la peau verte a des cheveux roux en bataille. Ses vêtements déchirés lui donnent une apparence négligée.",
      3: "Son teint verdâtre et ses vêtements en lambeaux lui donnent l'air d'avoir traversé bien des épreuves. Sa chevelure ébouriffée accentue cette apparence peu soignée.",
    },
  },
  {
    id: "epouvantail",
    label: "l'épouvantail",
    type: "personnage",
    image: epouvantailImage,
    descriptions: {
      1: "Il a des cheveux en paille et un nez orange. Une petite citrouille décore son grand chapeau.",
      2: "Ce drôle de personnage aux cheveux de paille possède un petit nez triangulaire. Son grand chapeau est décoré d'une citrouille orange.",
      3: "Sa chevelure ressemble davantage à une botte de paille qu'à de véritables cheveux. Une petite citrouille décore son chapeau tandis qu'un nez triangulaire orne son visage.",
    },
  },
  {
    id: "fantome",
    label: "le fantôme",
    type: "personnage",
    image: fantomeImage,
    descriptions: {
      1: "Il a un corps blanc qui brille et un grand sourire. Il flotte dans les airs.",
      2: "Ce personnage au corps blanc et lumineux flotte doucement dans les airs. Son grand sourire lui donne un air joyeux.",
      3: "Cette mystérieuse créature au corps immatériel et à l'éclat blanchâtre semble flotter dans les airs, tandis qu'un large sourire illumine son visage malicieux.",
    },
  },
  {
    id: "squelette",
    label: "le squelette",
    type: "personnage",
    image: squeletteImage,
    descriptions: {
      1: "Il a une tête en forme de crâne et de grands yeux ronds. Il porte une cape rouge à capuche.",
      2: "Ce personnage possède un visage en forme de crâne et de grands yeux ronds. Une cape rouge à capuche dissimule presque tout son corps.",
      3: "Cette créature au visage squelettique et aux yeux cerclés de noir dissimule son corps sous une cape ample et écarlate, dont la capuche recouvre son crâne.",
    },
  },
  {
    id: "momie",
    label: "la momie",
    type: "personnage",
    image: momieImage,
    descriptions: {
      1: "Elle a des bandes de tissu sur tout le corps.",
      2: "Ce personnage est entièrement enveloppé de bandelettes de tissu beige. Certaines se détachent et flottent autour de son corps.",
      3: "Enveloppée de la tête aux pieds par des bandelettes jaunâtres, cette créature semble tout droit sortie d'un tombeau ancien. Quelques morceaux s'échappent de son étrange tenue.",
    },
  },
  {
    id: "chat",
    label: "le chat sorcier",
    type: "personnage",
    image: chatImage,
    descriptions: {
      1: "Il a des poils noirs et des yeux verts. Il porte un grand chapeau violet décoré d'étoiles.",
      2: "Son pelage noir fait ressortir ses grands yeux verts. Il porte un chapeau violet décoré de lunes et d'étoiles dorées.",
      3: "Deux yeux émeraude brillent au milieu d'un pelage aussi sombre que la nuit. Un imposant couvre-chef violet, constellé de symboles célestes, lui donne l'allure d'un apprenti magicien.",
    },
  },
  {
    id: "frankenstein",
    label: "Frankenstein",
    type: "personnage",
    image: frankensteinImage,
    descriptions: {
      1: "Il a la peau verte et une grande cicatrice sur le front. On voit deux boulons sur sa tête.",
      2: "Sa peau verdâtre et sa grande cicatrice sur le front lui donnent une drôle d'apparence. Deux boulons métalliques dépassent de chaque côté de sa tête.",
      3: "Une longue cicatrice barre son front verdâtre. Deux imposantes pièces métalliques dépassent de part et d'autre de sa tête, comme si ce garçon avait été assemblé dans un atelier.",
    },
  },
  {
    id: "farfadet",
    label: "le farfadet",
    type: "personnage",
    image: farfadetImage,
    descriptions: {
      1: "Il a des cheveux roux et des oreilles pointues. Il porte un chapeau violet avec une tête de mort.",
      2: "Ses grandes oreilles pointues dépassent de ses cheveux roux en bataille. Il porte un chapeau violet décoré d'une petite tête de mort.",
      3: "Ses oreilles démesurées émergent d'une chevelure rousse ébouriffée. Sur son couvre-chef violet, un petit crâne et des feuilles automnales composent une décoration aussi étrange que colorée.",
    },
  },
  {
    id: "mariee",
    label: "la mariée fantôme",
    type: "personnage",
    image: marieeImage,
    descriptions: {
      1: "Elle a de longs cheveux blancs et des fleurs sur la tête. Elle porte une belle robe blanche.",
      2: "Ses longs cheveux blancs aux reflets mauves sont décorés d'une couronne de fleurs. Elle porte une élégante robe blanche en dentelle.",
      3: "Sa longue chevelure pâle flotte délicatement autour de son visage. Une somptueuse robe de dentelle blanche et une couronne de fleurs fanées évoquent une cérémonie passée.",
    },
  },
  {
    id: "citrouille",
    label: "la citrouille",
    type: "personnage",
    image: citrouilleImage,
    descriptions: {
      1: "Il a une tête ronde et orange avec une tige sur le dessus. Des feuilles couvrent ses épaules.",
      2: "Sa grosse tête orange est surmontée d'une tige enroulée sur elle-même. Des feuilles aux couleurs de l'automne recouvrent ses épaules.",
      3: "Une tige torsadée couronne son visage rond aux couleurs flamboyantes. Des feuilles automnales habillent ses épaules, comme si un légume du potager avait soudain pris vie.",
    },
  },
  {
    id: "fee",
    label: "la fée noire",
    type: "personnage",
    image: feeImage,
    descriptions: {
      1: "Elle a des cheveux foncés attachés en chignon. Des ailes violettes brillent dans son dos.",
      2: "Ses cheveux sombres sont relevés en un chignon volumineux, tandis que ses ailes violettes s'ouvrent dans son dos.",
      3: "Sa chevelure sombre parsemée de mèches violettes est rassemblée en un chignon désordonné. Dans son dos se déploient deux ailes étincelantes.",
    },
  },
  {
    id: "grimoire",
    label: "le grimoire",
    type: "objet",
    image: grimoireImage,
    descriptions: {
      1: "Il a une couverture violette avec une lune dorée. Une petite serrure permet de le fermer.",
      2: "Sa couverture violette est décorée de lunes et d'étoiles dorées. Un fermoir métallique permet de garder ses pages bien fermées.",
      3: "Sa couverture de cuir violet est ornée de symboles célestes. Cet ouvrage garde ses secrets sous clé grâce à un fermoir métallique finement ciselé.",
    },
  },
  {
    id: "cle",
    label: "la clé",
    type: "objet",
    image: cleImage,
    descriptions: {
      1: "Elle est dorée et permet d'ouvrir des portes.",
      2: "Entièrement dorée, elle est faite en métal et décorée d'une étoile. Elle permet d'ouvrir les portes fermées à double tour.",
      3: "Ses arabesques dorées lui donnent l'allure d'un bijou, mais sa véritable fonction est de déverrouiller les portes les plus mystérieuses, derrière lesquelles pourraient se dissimuler bien des secrets.",
    },
  },
  {
    id: "miroir",
    label: "le miroir",
    type: "objet",
    image: miroirImage,
    descriptions: {
      1: "Il est ovale, avec un bord doré. Il permet de voir son visage.",
      2: "Sa surface ovale permet d'observer son reflet, tandis que son cadre doré est décoré de petites fleurs et de motifs élégants.",
      3: "Sa surface réfléchissante, légèrement ternie par le temps, permet de contempler son propre reflet. Son cadre ovale aux ornements dorés lui confère une élégance ancienne.",
    },
  },
  {
    id: "couronne-de-fleurs",
    label: "la couronne de fleurs",
    type: "objet",
    image: couronneDeFleursImage,
    descriptions: {
      1: "Elle est faite de fleurs et de feuilles. On la porte sur la tête.",
      2: "Des fleurs fanées et des feuilles dorées forment un joli cercle que l'on peut porter sur la tête pour décorer sa coiffure.",
      3: "Elle est composée de délicates fleurs flétries et de fines branches entrelacées. C'est un accessoire destiné à agrémenter une coiffure élégante.",
    },
  },
  {
    id: "montre",
    label: "la montre à gousset",
    type: "objet",
    image: montreImage,
    descriptions: {
      1: "Elle est ronde et dorée, avec une longue chaîne. Ses aiguilles indiquent l'heure.",
      2: "Son boîtier rond et doré est décoré de petites fleurs. Reliée à une longue chaîne, elle possède deux aiguilles qui permettent de lire l'heure.",
      3: "Ses aiguilles poursuivent leur course sur un cadran aux chiffres romains. Relié à une longue chaîne, ce petit objet doré permet de garder le temps à portée de main.",
    },
  },
  {
    id: "flacon",
    label: "le flacon de potion",
    type: "objet",
    image: flaconImage,
    descriptions: {
      1: "Il est rempli d'une potion violette qui brille. Il se ferme avec un bouchon.",
      2: "Ce flacon en verre contient une mystérieuse potion violette aux reflets brillants. Un bouchon en liège empêche le liquide magique de s'échapper.",
      3: "Enfermé dans un flacon de verre, un mystérieux liquide violet scintille de mille feux. Son bouchon de liège empêche le précieux mélange de s'échapper et préserve ses pouvoirs.",
    },
  },
  {
    id: "chandelier",
    label: "le chandelier",
    type: "objet",
    image: chandelierImage,
    descriptions: {
      1: "Il est doré et porte trois bougies. Il éclaire la pièce.",
      2: "Ses trois branches dorées soutiennent des bougies allumées. Leurs flammes éclairent la pièce d'une douce lumière.",
      3: "Ses trois bras élégamment courbés soutiennent des bougies dont la cire fondue s'écoule lentement. Leurs flammes vacillantes diffusent une lueur chaleureuse, illuminant les alentours.",
    },
  },
  {
    id: "boite-a-bijoux",
    label: "la boîte à bijoux",
    type: "objet",
    image: boiteABijouxImage,
    descriptions: {
      1: "Dans une boîte bleue et dorée, une petite danseuse tourne avec la musique.",
      2: "À l'intérieur d'un joli coffret décoré de dorures, une petite danseuse tourne sur elle-même au rythme d'une douce mélodie.",
      3: "À l'intérieur de ce coffret aux ornements dorés, une figurine de danseuse pivote gracieusement sur son socle, tandis qu'un mécanisme dissimulé joue une mélodie envoûtante.",
    },
  },
  {
    id: "collier",
    label: "le collier",
    type: "objet",
    image: collierImage,
    descriptions: {
      1: "Il se porte autour du cou. Il est doré avec de belles pierres rouges.",
      2: "Sa chaîne dorée est décorée de plusieurs pierres rouges et brillantes. Une pierre plus grosse se trouve au centre de ce bijou porté autour du cou.",
      3: "Une délicate chaîne dorée rassemble plusieurs rubis étincelants autour d'une imposante pierre centrale. Ce précieux bijou est destiné à mettre en valeur le cou de celle qui le porte.",
    },
  },
  {
    id: "baguette-magique",
    label: "la baguette magique",
    type: "objet",
    image: baguetteMagiqueImage,
    descriptions: {
      1: "Elle est longue et en bois. On la tient dans la main pour faire de la magie.",
      2: "Son long manche en bois se termine par une pierre violette et brillante. Elle permet de lancer des sorts magiques.",
      3: "A l'extrémité de ce bâton finement sculpté, un cristal violet semble concentrer de mystérieux pouvoirs. Dans les mains d'un magicien, un simple geste suffirait à déclencher de puissants sortilèges.",
    },
  },
  {
    id: "lanterne",
    label: "la lanterne",
    type: "objet",
    image: lanterneImage,
    descriptions: {
      1: "Elle est dorée avec des vitres. On peut la porter pour éclairer la nuit.",
      2: "Ses parois de verre laissent passer la lumière. Un anneau permet de la transporter pour éclairer son chemin dans l'obscurité.",
      3: "Derrière ses parois vitrées, une lumière scintillante repousse l'obscurité. Sa structure métallique et son anneau permettent de l'emporter pour illuminer les endroits les plus sombres.",
    },
  },
  {
    id: "coffre",
    label: "le coffre de bonbons",
    type: "objet",
    image: coffreImage,
    descriptions: {
      1: "Il contient beaucoup de bonbons colorés. Son couvercle est ouvert.",
      2: "Son couvercle ouvert laisse découvrir une montagne de bonbons colorés. Il permet de conserver les friandises à l'abri jusqu'à la fête d'Halloween.",
      3: "Sous son imposant couvercle entrouvert se cache un véritable trésor de gourmandises multicolores. Elles sont destinées à régaler les invités lors des festivités d'Halloween.",
    },
  },
  {
    id: "boule-de-cristal",
    label: "la boule de cristal",
    type: "objet",
    image: bouleDeCristalImage,
    descriptions: {
      1: "Elle est ronde et permet de voir le futur grâce à la magie.",
      2: "Posée sur un support doré, elle est toute en verre. Les magiciens l'utilisent pour prédire l'avenir et découvrir des secrets cachés.",
      3: "Reposant sur un socle doré, sa surface transparente laisse entrevoir un tourbillon d'étoiles scintillantes, dans lequel les magiciens tentent de lire l'avenir et de percer les mystères du destin.",
    },
  },
  {
    id: "masque",
    label: "le masque",
    type: "objet",
    image: masqueImage,
    descriptions: {
      1: "Il se porte sur le visage pour se déguiser. Il est doré, avec des plumes et deux trous pour les yeux.",
      2: "Décoré de grandes plumes et de motifs dorés, il cache une partie du visage. Deux ouvertures permettent de voir sans être reconnu.",
      3: "Richement décoré et surmonté de somptueuses plumes, cet accessoire dissimule une partie du visage tout en laissant le regard libre. Il permet de préserver son anonymat lors d'un bal costumé.",
    },
  },
  {
    id: "clochette",
    label: "la clochette",
    type: "objet",
    image: clochetteImage,
    descriptions: {
      1: "C'est un objet en métal qui produit du son quand on le secoue.",
      2: "Lorsqu'on l'agite, elle produit un son puissant. Elle permet de prévenir quelqu'un ou d'attirer son attention.",
      3: "C'est un objet métallique qui émet un tintement cristallin lorsqu'on l'agite. Il permet ainsi de signaler sa présence, d'attirer l'attention ou d'annoncer le début d'un événement.",
    },
  },
  {
    id: "armurerie",
    label: "l'armurerie",
    type: "lieu",
    image: armurerieImage,
    descriptions: {
      1: "Dans cette salle du château, on range les épées, les boucliers et les armures des soldats.",
      2: "Dans cette pièce, les chevaliers viennent chercher leurs épées, leurs boucliers et leurs armures pour se préparer au combat.",
      3: "Cette salle abrite une importante collection d'armes et d'équipements de protection, soigneusement rangés afin que les chevaliers puissent s'équiper avant de partir défendre le royaume.",
    },
  },
  {
    id: "bibliotheque",
    label: "la bibliothèque",
    type: "lieu",
    image: bibliothequeImage,
    descriptions: {
      1: "Dans cette salle, les livres sont rangés sur des étagères. On s'y installe pour lire.",
      2: "Cette vaste pièce abrite des centaines de livres rangés sur de hautes étagères. Les visiteurs peuvent s'installer autour des tables pour lire et faire des recherches.",
      3: "Cette immense salle renferme une précieuse collection d'ouvrages anciens, disposés sur de hautes étagères. Ce lieu offre aux visiteurs un endroit paisible pour consulter des textes et approfondir leurs connaissances.",
    },
  },
  {
    id: "jardin",
    label: "le jardin",
    type: "lieu",
    image: jardinImage,
    descriptions: {
      1: "On peut se promener parmi les fleurs et les arbres. Des bancs permettent de se reposer.",
      2: "Autour du château, des allées bordées de fleurs et d'arbres invitent les visiteurs à se promener. Des bancs permettent de profiter du calme et de la beauté de la nature.",
      3: "À l'extérieur du château, de paisibles allées serpentent entre les arbres et les parterres fleuris, offrant aux promeneurs un espace de détente où ils peuvent admirer la végétation, profiter de la tranquillité des lieux ou se reposer sur les bancs.",
    },
  },
  {
    id: "salle-de-bal",
    label: "la salle de bal",
    type: "lieu",
    image: salleDeBalImage,
    descriptions: {
      1: "Dans cette grande salle du château, on peut danser et écouter de la musique.",
      2: "Cette vaste salle accueille les grandes fêtes où les invités se réunissent pour danser au son du piano, sous de magnifiques lustres.",
      3: "Cette somptueuse salle, illuminée par d'imposants lustres de cristal, accueille de prestigieuses réceptions au cours desquelles les invités évoluent sur une vaste piste de danse, accompagnés par les mélodies d'un piano.",
    },
  },
  {
    id: "laboratoire",
    label: "le laboratoire de magie",
    type: "lieu",
    image: laboratoireImage,
    descriptions: {
      1: "Dans cette salle, on prépare des potions magiques avec un grand chaudron.",
      2: "Dans cette pièce secrète, les magiciens mélangent des ingrédients dans un grand chaudron pour fabriquer des potions.",
      3: "A l'abri des regards, les alchimistes associent d'étranges ingrédients dans un chaudron bouillonnant. Leurs expériences pourraient bien donner naissance à des préparations aux pouvoirs insoupçonnés.",
    },
  },
]

/** Configuration de l'enquête d'Halloween : « Mystère au château » */
export const HALLOWEEN_CONFIG: DetectiveCluxConfig = {
  title: HALLOWEEN_TITLE,
  images: {
    fond: fondImage,
    enveloppe: enveloppeImage,
    logo: logoImage,
    fondReglages: fondReglagesImage,
    parchemin: parcheminImage,
    detective: detectiveImage,
    roi: roiImage,
  },
  reglages: {
    introduction: (
      <>
        <p>
          Ce soir, le château se prépare pour la grande{" "}
          <span className="dc-reglages__accent">fête d&apos;Halloween</span> !
          Mais alors que les invités commencent à arriver, une étrange nouvelle
          vient troubler les festivités :{" "}
          <strong>un objet précieux a mystérieusement disparu !</strong>
        </p>
        <p>
          Le roi, très inquiet, fait appel au célèbre Détective Clux pour
          résoudre cette affaire. Armé de sa fidèle loupe et de son flair
          légendaire, notre détective se lance à la recherche d&apos;indices.
        </p>
      </>
    ),
    question: "Qui a dérobé l'objet ? Où est-il caché ?",
    conclusion: (
      <>
        <p>
          Pour résoudre ce mystère, Clux aura besoin de{" "}
          <span className="dc-reglages__accent">ton aide</span> ! Lis
          attentivement les indices, retrouve le coupable, l&apos;objet dérobé
          et le lieu du château où il a été caché.
        </p>
        <p>
          <strong>
            Aide vite le détective Clux à découvrir la vérité avant le début de
            la fête !
          </strong>
        </p>
      </>
    ),
  },
  messages: {
    suspicion: ({ personnage, objet, lieu }) => (
      <>
        Mmh, je soupçonne <strong>{personnage.label}</strong> d'avoir caché{" "}
        <strong>{objet.label}</strong> dans <strong>{lieu.label}</strong>.
      </>
    ),
    roiConfirmation: "D'accord, vérifions !",
    roiSucces:
      "Voilà une enquête bien menée, félicitations Détective Clux ! Vous êtes exceptionnel !",
    roiEchec: ({ personnage, objet, lieu }) => (
      <>
        Hmm… ce n'est pas tout à fait ça ! Le coupable était{" "}
        <strong>{personnage.label}</strong>, qui avait caché{" "}
        <strong>{objet.label}</strong> dans <strong>{lieu.label}</strong>.
      </>
    ),
  },
  items: HALLOWEEN_ITEMS,
}
